// <s-sticky-buy-bar> reveals a compact mobile buy bar once the main add-to-cart
// button scrolls out of view, and flags the root element so floating widgets
// (like the WhatsApp button) can lift above it.
class StickyBuyBar extends HTMLElement {
  #observer = null;

  connectedCallback() {
    const form = this.closest('form');
    const target = form?.querySelector('[data-main-add]');
    if (!target || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      // Only show once the button has scrolled above the viewport, not before reaching it.
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-visible', passed);
      this.inert = !passed;
      document.documentElement.toggleAttribute('data-sticky-buy', passed);
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
    document.documentElement.removeAttribute('data-sticky-buy');
  }
}

if (!customElements.get('s-sticky-buy-bar')) {
  customElements.define('s-sticky-buy-bar', StickyBuyBar);
}
